import initializeApp from 'actions/app/initializeApp';
import sendPendingMessages from 'actions/messages/sendPendingMessages';
import appEvents from 'events/app';

export default (async function authenticateWithChatProvider(
  dispatch,
  getState,
  { chatGateway, messageGateway, sessionGateway }
) {
  const authCredentials = sessionGateway.getSession();

  try {
    await chatGateway.login(authCredentials);

    dispatch(appEvents.clientAuthenticationSuccess(authCredentials));

    messageGateway.requestSession();

    dispatch(sendPendingMessages()); // this is hacky. its legacy but we should prob remove this
  } catch (error) {
    dispatch(appEvents.clientAuthenticationError(error));
  }

  dispatch(initializeApp);
});
